// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"styles_itemsContainer__l9Pb0","dots":"styles_dots__BKWSX","spacer":"styles_spacer__1PI41","displayText":"styles_displayText__3RYra"};